<template>
  <div>
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>

    <site-modal
      ID="emergencySessionModal"
      modalSize="medium"
      modalHeaderClass="bg-gray-700 text-yellowTheme"
      :modalClass="isInformationModalShown ? 'hideModal' : 'showModal'"
      @closed="cancelModal"
    >
      <template #header>
        <div class="row">
          <h6>
            <i class="fi fi-support-1"></i>
            درخواست برگزاری جلسه اورژانسی
          </h6>
        </div>
      </template>
      <template #body>
        <validation-summery
          v-if="modalHasError"
          :errors="modalError"
        ></validation-summery>
        <div class="card border-0 shadow-none">
          <div class="card-body">
            <div class="row justify-content-center">
              <div class="col-md-12 my-1 p-3 rounded border shadow">
                <!-- v-if="myTherapistList.length > 0" -->
                <div class="form-check">
                  <!-- <input
                    class="form-check-input form-check-input-default"
                    type="radio"
                    value=""
                    id="myTherapistRadio"
                    name="therapistRadio"
                    :checked="therapistFilterStatus == 'myTherapist'"
                    @click="myTherapistRadioClick"
                  /> -->
                  <label
                    class="form-check-label"
                    for="myTherapistRadio"
                    style="text-wrap: nowrap"
                  >
                    درمانگر مورد نظر خود را انتخاب نمایید:
                    <!-- v-if="therapistFilterStatus == 'myTherapist'" -->
                    <span class="text-danger">*</span>
                  </label>
                  <!-- :disabled="therapistFilterStatus != 'myTherapist'" -->
                  <combo-Box-With-Message
                    warningSelectRow=""
                    errorText="انتخاب درمانگر الزامی است"
                    ref="myTherapistSelect"
                    errorClass=" text-danger"
                    topTitleClass="mb-1"
                    topTitle=""
                    comboClass="text-end mt-1"
                    :comboList="myTherapistList"
                    v-model:selectedItem="myTherapistID"
                    itemKey="id"
                    itemValue="title"
                    comboSize="sm"
                  />
                </div>

                <!-- <div class="form-check my-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    value=""
                    id="newTherapistRadio"
                    name="therapistRadio"
                    @click="newTherapistRadioClick"
                    :checked="therapistFilterStatus == 'newTherapist'"
                  />
                  <label class="form-check-label" for="newTherapistRadio">
                    مایل هستم خودم درمانگرم را انتخاب کنم:
                  </label>
                  <searchable-input
                    :disabled="therapistFilterStatus != 'newTherapist'"
                    mode="single"
                    placeHolder="جستجو درمانگر..."
                    errorText="انتخاب درمانگر الزامی است"
                    ref="newTherapistSelect"
                    :loading="isLoadingNewTherapistList"
                    :options="newTherapistList"
                    v-model:inputValue="newTherapistID"
                    @searchChange="newTherapistSearchKeyPress"
                    inputThem="purpleThem"
                    :canDeselect="false"
                    :canClear="true"
                    topTitle=""
                    inputTitle=""
                    topTitleClass="mt-1"
                  />
                </div> -->

                <!-- <div class="form-check my-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    value=""
                    id="dontcareTherapistRadio"
                    name="therapistRadio"
                    @click="dontcareTherapistRadioClick"
                    :checked="therapistFilterStatus == 'dontCareTherapist'"
                  />
                  <label class="form-check-label" for="dontcareTherapistRadio">
                    مایل هستم کلینیک برایم درمانگر مناسب انتخاب نماید:
                  </label>
                </div> -->

                <div
                  class="row"
                  v-if="therapistFilterStatus == 'dontCareTherapist'"
                >
                  <div class="col-md-12">
                    <combo-Box-With-Message
                      :required="true"
                      warningSelectRow=""
                      errorText="انتخاب حوزه الزامی است"
                      ref="scopeSelect"
                      errorClass=" text-danger"
                      topTitleClass="mb-1"
                      topTitle="حوزه:"
                      comboClass="text-end mt-1"
                      :comboList="scopeList"
                      v-model:selectedItem="entity.scopeID"
                      @comboOnChanged="scopeChanged"
                      itemKey="id"
                      itemValue="title"
                      comboSize="sm"
                    />
                  </div>
                  <!-- <div class="col-md-6">
                    <combo-Box-With-Message
                      :required="true"
                      warningSelectRow=""
                      errorText="انتخاب موضوع الزامی است"
                      ref="topicSelect"
                      errorClass=" text-danger"
                      topTitleClass="mb-1"
                      topTitle="موضوع:"
                      comboClass="text-end mt-1"
                      :comboList="topicList"
                      v-model:selectedItem="entity.topicID"
                      itemKey="id"
                      itemValue="title"
                      comboSize="sm"
                    />
                  </div> -->
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <date-time-picker
                      ref="sessionDateInput"
                      :initialValue="entity.sessionDate"
                      color="#506690"
                      errorMessage="انتخاب تاریخ الزامی است"
                      topTitleClass="mb-1"
                      dateTimePickerClass=""
                      initialValueType="en"
                      placeholder=""
                      :min="minDate"
                      :max="maxDate"
                      v-model:gregorianDate="entity.sessionDate"
                      topTitle="تاریخ پیشنهادی خود را وارد کنید:"
                      :required="true"
                      containerClass="mt-1"
                      type="date"
                      :disableDateTimes="disableDates"
                      @dateChanged="sessionDateChanged"
                      :disabled="
                        !entity.scopeID &&
                        therapistFilterStatus == 'dontCareTherapist'
                      "
                    />
                    <!-- v-model:dateTime="entity.sessionDate" -->
                  </div>
                  <div class="col-md-6 position-relative">
                    <combo-Box-With-Message
                      :required="true"
                      warningSelectRow=""
                      errorText="انتخاب بازه زمانی الزامی است"
                      ref="timePeriodSelect"
                      errorClass=" text-danger"
                      topTitleClass="mb-1"
                      topTitle="بازه زمانی مورد نظر خود را مشخص کنید:"
                      comboClass="text-end mt-1"
                      :comboList="timePeriodList"
                      v-model:selectedItem="entity.sessionTimePeriod"
                      itemKey="id"
                      itemValue="title"
                      comboSize="sm"
                      :disabled="
                        therapistFilterStatus == 'dontCareTherapist' &&
                        (entity.sessionDate == '' || entity.sessionDate == null)
                      "
                    />
                  </div>
                </div>

                <!-- <input-with-message
                  copmponentType="textArea"
                  containerClass="col-12 mt-2"
                  topTitle="توضیحات:"
                  inputThem="grayThem"
                  :iconSpin="false"
                  inputType="text"
                  :showMessage="false"
                  v-model:inputValue="entity.description"
                  :hasSideBox="false"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="m-auto">
          <button class="btn btn-sm rounded btn-danger" @click="confirmedModal">
            <i class="fi fi-box-checked"></i>
            تایید
          </button>
          <button
            class="btn btn-sm rounded btn-warning"
            @click="openInformationModal"
          >
            راهنما
          </button>
          <button class="btn btn-sm rounded btn-blueSite" @click="cancelModal">
            <i class="fi fi-close"></i>
            انصراف
          </button>
        </div>
      </template>
    </site-modal>

    <site-modal ID="applyChangesConfirmModal" @closed="cancelModal">
      <template #header>
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            ></path>
          </svg>
          اعمال تغییرات
        </h6>
      </template>
      <template #body>
        <validation-summery
          v-if="modalApplyChangesHasError"
          :errors="applyChangesModalError"
        ></validation-summery>
        <p>
          از اعمال تغییرات پیشنهاد شده درمانگر بر روی درخواست جلسه اورژانسی خود،
          اطمینان دارید؟
        </p>
        <div>
          <span class="d-block text-danger smaller mb-1"
            ><b> پیشنهاد جلسه ارائه شده (توسط درمانگر): </b>
          </span>
          <span class="smaller mb-1 ms-2"
            >تاریخ:
            <b
              >{{ getPersianDate(selectedSuggestedDate) }}
              <span v-if="isOverseas()">
                |
                <small class="gregorianDateClass"
                  >{{ getGregorianDate(selectedSuggestedDate) }}
                </small></span
              ></b
            ></span
          >
          <span class="smaller mb-1 ms-2"
            >از: <b>{{ getTime(selectedSuggestedFromTime) }}</b></span
          >
          <span class="smaller mb-1 ms-2"
            >تا: <b>{{ getTime(selectedSuggestedToTime) }}</b></span
          >
        </div>
      </template>
      <template #footer>
        <div class="m-auto">
          <button
            class="btn btn-sm rounded btn-blueSite"
            @click="confirmedApplyChangesModal"
          >
            <i class="fi fi-box-checked"></i>
            تایید
          </button>
          <button class="btn btn-sm rounded btn-blueSite" @click="cancelModal">
            <i class="fi fi-close"></i>
            انصراف
          </button>
        </div>
      </template>
    </site-modal>
    <site-modal
      ID="approveSessionModal"
      modalSize="medium"
      modalHeaderClass="bg-gray-700 text-yellowTheme"
      @closed="cancelModal"
    >
      <template #header>
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            ></path>
          </svg>
          {{ !emergencySessionEntity.hasInvoice ? 'تایید و بررسی' : 'تسویه' }}
          جلسه اورژانسی
        </h6>
      </template>
      <template #body>
        <validation-summery
          v-if="modalHasError"
          :errors="modalError"
        ></validation-summery>
        <div
          class="card border-secondary shadow-none"
          v-if="!emergencySessionEntity.hasInvoice"
        >
          <div class="card-header bg-light">
            <span class="text-danger">مشخصات جلسه اورژانسی</span>
          </div>
          <div class="card-body">
            <div class="row justify-content-between">
              <div class="col-12 col-lg-6 col-md-12">
                <div class="row mt-3">
                  <div class="col-4">تاریخ جلسه:</div>
                  <div class="col-8 fw-bold">
                    {{ getPersianDate(emergencySessionEntity.sessionDate) }}

                    <small class="gregorianDateClass" v-if="isOverseas()"
                      >{{
                        getGregorianDate(emergencySessionEntity.sessionDate)
                      }}
                    </small>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-4">نوع جلسه:</div>
                  <div class="col-8 fw-bold">
                    {{ emergencySessionEntity.sessionType }}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-4">درمانگر:</div>
                  <div class="col-8 fw-bold">
                    {{ emergencySessionEntity.therapistName }}
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6 col-md-12">
                <div class="row mt-3">
                  <div class="col-4">از ساعت:</div>
                  <div class="col-8 fw-bold">
                    {{ getTime(emergencySessionEntity.fromTime) }}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-4">تا ساعت:</div>
                  <div class="col-8 fw-bold">
                    {{ getTime(emergencySessionEntity.toTime) }}
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-4">تعرفه قیمت:</div>
                  <div class="col-8">
                    <combo-Box-With-Message
                      v-if="emergencySessionEntity.sessionTariffList.length > 1"
                      warningSelectRow=""
                      errorText="انتخاب تعرفه الزامی است"
                      ref="sessionTariffPriceSelect"
                      errorClass="text-danger"
                      topTitle=""
                      comboClass="text-end"
                      :comboList="emergencySessionEntity.sessionTariffList"
                      v-model:selectedItem="selectedTariffPriceDetailID"
                      itemKey="tariffPriceDetailID"
                      itemValue="title"
                      :hasSideBox="false"
                      comboSize="sm"
                    />
                    <span
                      v-if="
                        emergencySessionEntity.sessionTariffList.length == 1
                      "
                      :class="
                        emergencySessionEntity.sessionTariffList[0]
                          .clientCanceledSessionID > 0
                          ? 'text-danger'
                          : ''
                      "
                    >
                      {{
                        emergencySessionEntity.sessionTariffList[0].title
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="card border-secondary shadow-none"
          v-if="emergencySessionEntity.hasInvoice"
        >
          <div class="card-header bg-blue">
            <span class="text-yellowTheme">مشخصات صورت حساب</span>
          </div>
          <div class="card-body">
            <validation-summery
              v-if="checkoutInvoiceHasError"
              :errors="checkoutInvoiceModalError"
            ></validation-summery>
            <div class="row justify-content-between">
              <div class="col-12 col-lg-6 col-md-12">
                <div class="row mt-3">
                  <div class="col-4">شماره:</div>
                  <div class="col-8 fw-bold">
                    {{ emergencySessionEntity.invoiceCode }}
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-4">تاریخ جلسه:</div>
                  <div class="col-8 fw-bold">
                    {{ getPersianDate(emergencySessionEntity.sessionDate) }}
                    <small class="gregorianDateClass" v-if="isOverseas()"
                      >{{
                        getGregorianDate(emergencySessionEntity.sessionDate)
                      }}
                    </small>
                  </div>
                  <div class="row mt-3">
                    <div class="col-4">زمان جلسه:</div>
                    <div class="col-8 fw-bold" dir="ltr">
                      {{ getTime(emergencySessionEntity.fromTime) }} -
                      {{ getTime(emergencySessionEntity.toTime) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6 col-md-12">
                <div class="row mt-3">
                  <div class="col-4">نوع جلسه:</div>
                  <div class="col-8 fw-bold">
                    {{ emergencySessionEntity.sessionType }}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-4">درمانگر:</div>
                  <div class="col-8 fw-bold">
                    {{ emergencySessionEntity.therapistName }}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-4">قیمت:</div>
                  <div class="col-8 fw-bold">
                    {{ getThousand(emergencySessionEntity.price) }}
                    <span class="smaller me-2">{{
                      getWalletCurrencyTitle()
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <hr class="hr-conclusion my-3" />
            <div class="row justify-content-center">
              <div class="col-6 col-md-3">جمع کل:</div>
              <div class="col-6 col-md-4 fw-bold">
                {{ getThousand(emergencySessionEntity.price ?? 0) }}
                <span class="smaller me-2">{{ getWalletCurrencyTitle() }}</span>
              </div>
            </div>
            <div class="row justify-content-center mt-2">
              <div class="col-6 col-md-3">موجودی کیف پول:</div>
              <div class="col-6 col-md-4 fw-bold">
                {{ getThousand(selectedWalletForInvoice.balance) }}
                <span class="smaller me-2">{{ getWalletCurrencyTitle() }}</span>
              </div>
            </div>
            <div class="row justify-content-center mt-2">
              <div class="col-md-7">
                <check-box-with-message
                  v-if="emergencySessionEntity.currencyTypeID == 1"
                  title="استفاده از موجودی کیف پول جهت تسویه صورت حساب"
                  color="#506690"
                  checkBoxClass="ms-2"
                  containerClass=""
                  v-model:checkBoxValue="usingWalletBalance"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="m-auto">
          <button
            class="btn btn-sm rounded"
            @click="confirmedApproveSessionModal"
            :class="{
              'btn-blueSite': !emergencySessionEntity.hasInvoice,
              'btn-success': emergencySessionEntity.hasInvoice,
              'text-light': emergencySessionEntity.hasInvoice,
            }"
          >
            <i class="fi fi-box-checked"></i>
            {{ !emergencySessionEntity.hasInvoice ? 'تایید' : 'تسویه' }}
          </button>
          <button class="btn btn-sm rounded btn-blueSite" @click="cancelModal">
            <i class="fi fi-close"></i>
            انصراف
          </button>
        </div>
      </template>
    </site-modal>

    <site-modal
      ID="approveSessionConfirmModal"
      @closed="cancelApproveConfirmModal"
    >
      <template #header>
        <h6 class="">
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-exclamation-triangle-fill"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
            ></path>
          </svg>
          هشدار
        </h6>
      </template>
      <template #body>
        <validation-summery
          v-if="modalApproveSessionHasError"
          :errors="approveSessionModalError"
        ></validation-summery>
        <p class="justified">
          {{ approveModalMessage }}
        </p>
      </template>
      <template #footer>
        <div class="m-auto">
          <button
            class="btn btn-sm rounded btn-success text-light"
            @click="confirmedApproveSessionDialog"
          >
            <i class="fi fi-box-checked"></i>
            {{ approveConfirmMode == 'invoice' ? 'صدور' : 'پرداخت / تسویه' }}
          </button>
          <button
            class="btn btn-sm rounded btn-blueSite"
            @click="cancelApproveConfirmModal"
          >
            <i class="fi fi-close"></i>
            انصراف
          </button>
        </div>
      </template>
    </site-modal>
    <site-modal
      ID="informationModal"
      @closed="cancelInformationModal"
      modalSize="semiMedium"
    >
      <template #header>
        <h6 class="">
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-info-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            ></path>
            <path
              d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            ></path>
          </svg>
          راهنما
        </h6>
      </template>
      <template #body>
        <p class="justified">
          مراجع گرامی، در صورتی که تاکنون هیچ‌ گونه سابقه جلسه روان‌ درمانی یا
          روان ‌پزشکی با کادر درمان مجموعه ارگانیک مایندد نداشته‌اید، لطفاً برای
          دریافت نوبت اورژانسی با شماره
          <a href="tel:۰۲۱۹۱۰۰۵۱۴۱" class="text-blueSite text-dashed"
            >۹۱۰۰۵۱۴۱-۰۲۱</a
          >
          تماس حاصل فرمایید. اگر خارج از کشور هستید، می‌توانید از طریق واتس‌اپ
          به شماره ۹۰۳۱۳۰۹۱۵۶(۰۰۹۸) پیام دهید. همکاران ما در بخش پشتیبانی آماده
          پاسخگویی به شما هستند.
        </p>
      </template>
      <template #footer>
        <div class="m-auto">
          <button
            class="btn btn-sm rounded btn-blueSite"
            @click="cancelInformationModal"
          >
            <i class="fi fi-box-checked"></i>
            تایید
          </button>
        </div>
      </template>
    </site-modal>
    <div class="mt-2 text-secondary">
      <h4 class="display-7 position-relative">
        <div class="d-inline-block"></div>
        <!-- :href="`/panel/sessionsTab/${$store.getters.userPersonID}`" -->
        <a
          class="btn btn-sm float-end m-0 p-2"
          @click="returnButtonClick"
          :class="isMobile ? 'fs-8' : ''"
        >
          <template v-if="!isMobile"> بازگشت </template>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
            ></path>
          </svg>
        </a>
        <button
          class="btn btn-sm rounded btn-danger float-end animate-pulse"
          @click="addButtonClick"
          :class="isMobile ? 'fs-8' : ''"
        >
          ثبت جلسه اورژانسی
        </button>
      </h4>

      <hr class="hr-right" />
    </div>

    <div
      class="row justify-content-center my-3 scrollable-vertical scrollable-styled-dark"
      :style="isMobile ? '' : 'max-height: 70vh'"
    >
      <div class="col-12 col-lg-11">
        <div
          class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
          v-for="item in emergencyRequestData"
          :key="item.id"
        >
          <div
            class="card-body"
            :class="{
              'bg-success-soft': item.statusID == 6,
              'bg-danger-soft': item.statusID >= 7,
              'p-1 ps-2': showTherapistPrifile,
            }"
          >
            <div class="row g-4 position-relative">
              <div
                class="col-3 col-sm-3 col-md-3 col-lg-2 text-center border-1 border-start"
                :class="isMobile ? 'px-0' : ''"
                v-if="showTherapistPrifile"
              >
                <therapist-profile
                  :ID="item.therapistID"
                  :therapistName="item.therapistName"
                  tharpistNameClass="small fw-bold"
                  :psychology-organization-link="item.pschologyOrganizationLink"
                  :show-psychology-organization-link="
                    showPsychologyOrganizationLink
                  "
                />
              </div>

              <div
                :class="{
                  'col-9 col-sm-9 col-md-9 col-lg-9': showTherapistPrifile,
                  'col ': !showTherapistPrifile,
                }"
              >
                <div>
                  <span
                    class="d-block"
                    v-if="item.therapistID && !showTherapistPrifile"
                  >
                    <b>{{ item.therapistName }} </b>
                    <span class="smaller"> (درمانگر)</span>
                    <!-- PschologyOrganizationLink -->
                    <therapist-pschology-organication-link
                      :showPsychologyOrganizationLink="
                        !showTherapistPrifile && showPsychologyOrganizationLink
                      "
                      :psychologyOrganizationLink="
                        item.pschologyOrganizationLink
                      "
                    ></therapist-pschology-organication-link>
                  </span>
                  <span class="d-block small" v-if="item.scopeID">
                    <span class="fw-bold">حوزه: </span>
                    <span class="smaller">{{ item.scopeTitle }}</span>
                  </span>

                  <div>
                    <div class="fs-8">
                      <span class="fw-bold"> تاریخ جلسه: </span>
                      <span>
                        {{ getPersianDate(item.sessionDate) }}
                        <template v-if="isOverseas()">
                          |
                          <small class="gregorianDateClass"
                            >{{ getGregorianDate(item.sessionDate) }}
                          </small>
                        </template>
                      </span>
                    </div>
                    <div class="fs-8">
                      <span class="fw-bold"> وضعیت درخواست: </span>
                      <span
                        :class="{
                          'text-danger': item.statusID == 3,
                          'animate-pulse-danger':
                            item.statusID == 3 || item.statusID == 5,
                        }"
                        >{{
                          item.emergencyRequestStatus == 'صادر شده'
                            ? 'در حال بررسی'
                            : item.emergencyRequestStatus
                        }}</span
                      >
                    </div>
                    <div class="fs-8">
                      <span class="fw-bold"> تاریخ ثبت: </span>
                      <span class="smaller">
                        {{ getPersianDateTime(item.createdDate) }}
                        <span v-if="isOverseas()">
                          |
                          <small class="gregorianDateClass"
                            >{{ getGregorianDateTime(item.createdDate) }}
                          </small>
                        </span>
                      </span>
                    </div>
                    <div class="fs-8">
                      <span class="fw-bold"> بازه زمانی: </span>
                      <span class="smaller">
                        <span class="fw-bold">از </span>
                        <span>{{ getTime(item.fromTime) }}</span>
                        <span class="fw-bold me-2">تا </span>
                        <span>{{ getTime(item.toTime) }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="mt-2">
                  <div>
                    <a
                      v-if="item.statusID == 3"
                      href="#"
                      @click="
                        applyChangesButtonClick(
                          item.id,
                          item.suggestedSessionDate,
                          item.suggestedFromTime,
                          item.suggestedToTime
                        )
                      "
                      class="bg-mainPanel text-dark rounded px-2 py-1 small ms-1 animate-pulse"
                      >اعمال تغییرات
                      <svg
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-pencil-square"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                        ></path>
                      </svg>
                    </a>

                    <a
                      v-if="item.statusID == 5"
                      href="#"
                      @click="
                        approveSessionButtonClick(item.id, item.sessionID)
                      "
                      class="bg-mainPanel text-dark rounded px-2 py-1 small ms-1 animate-pulse"
                      >تایید و پرداخت
                      <svg
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-check-all"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div class="mt-2">
                  <a
                    class="small text-secondary"
                    :href="`#collapseDetail_${item.id}`"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    جزئیات
                    <!-- <i class="fi fi-arrow-down-slim"></i> -->
                    <svg
                      width="18px"
                      height="18px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-chevron-compact-down"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <div class="collapse" :id="`collapseDetail_${item.id}`">
              <div class="card card-body small justified">
                <div class="smaller">
                  <span class="d-block text-success mb-1"><b>توضیحات:</b></span>
                  {{ item.description }}
                </div>
              </div>
              <div
                class="card card-body small justified mt-1 bg-light"
                v-if="item.statusID == 3 || item.statusID == 4"
              >
                <div>
                  <span class="d-block text-danger smaller mb-1"
                    ><b> پیشنهاد جلسه ارائه شده (توسط درمانگر): </b>
                  </span>
                  <span class="smaller mb-1 ms-2"
                    >تاریخ:
                    <b
                      >{{ getPersianDate(item.suggestedSessionDate) }}
                      <span v-if="isOverseas()">
                        |
                        <small class="gregorianDateClass"
                          >{{ getGregorianDate(item.suggestedSessionDate) }}
                        </small></span
                      >
                    </b></span
                  >
                  <span class="smaller mb-1 ms-2"
                    >از: <b>{{ getTime(item.suggestedFromTime) }}</b></span
                  >
                  <span class="smaller mb-1 ms-2"
                    >تا: <b>{{ getTime(item.suggestedToTime) }}</b></span
                  >
                  <div class="smaller">
                    <span class="d-block my-1"><b>توضیحات:</b></span>
                    {{ item.therapistDescription }}
                  </div>
                </div>
              </div>

              <div
                class="card card-body small justified mt-1 bg-light"
                v-if="
                  item.statusID == 5 ||
                  item.statusID == 6 ||
                  item.statusID == 10
                "
              >
                <div>
                  <span class="d-block text-danger smaller mb-1"
                    ><b>جلسه تنظیم شده (توسط درمانگر): </b>
                  </span>
                  <span class="smaller mb-1 ms-2"
                    >تاریخ:
                    <b
                      >{{ getPersianDate(item.assignedSessionDate) }}
                      <span v-if="isOverseas()">
                        |
                        <small class="gregorianDateClass"
                          >{{ getGregorianDate(item.assignedSessionDate) }}
                        </small></span
                      >
                    </b></span
                  >
                  <span class="smaller mb-1 ms-2"
                    >از: <b>{{ getTime(item.assignedFromTime) }}</b></span
                  >
                  <span class="smaller mb-1 ms-2"
                    >تا: <b>{{ getTime(item.assignedToTime) }}</b></span
                  >
                  <div class="smaller">
                    <span class="d-block my-1"><b>توضیحات:</b></span>
                    {{ item.therapistDescription }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
          v-if="emergencyRequestData.length == 0"
        >
          <div class="card-body d-flex justify-content-between">
            <div class="w-100 pt-1 text-center">
              <strong class="d-block fs-6 fw-medium">
                درخواست جلسه اورژانسی وجود ندارد</strong
              >
            </div>
          </div>
        </div>
        <div class="text-center my-2">
          <button
            class="btn btn-soft btn-light btn-sm text-black"
            @click="moreEmergencyRequestClick"
            v-if="hasMoreRecord"
          >
            <i class="fi fi-plus"></i>
            <span>نمایش بیشتر</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
// import InputWithMessage from '../../../../components/form/inputWithMessage/InputWithMessage.vue';
import ComboBoxWithMessage from '../../../../components/form/comboBoxWithMessage/ComboBoxWithMessage.vue';
import axios from 'axios';
import { Modal } from 'bootstrap';
import ValidationSummery from '../../../../components/form/errorBox/ValidationSummery.vue';
// import SearchableInput from '../../../../components/form/searchableInput/SearchableInput.vue';
import CheckBoxWithMessage from '../../../../components/form/checkBoxWithMessage/CheckBoxWithMessage.vue';
import DateTimePicker from '../../../../components/form/dateTimePicker/DateTimePicker.vue';
import { useRoute } from 'vue-router';
import TherapistProfile from '../../../../components/data/therapistProfile/TherapistProfile.vue';
import TherapistPschologyOrganicationLink from '../../../../components/data/therapistPschologyOrganicationLink/TherapistPschologyOrganicationLink.vue';
import { isMobile } from 'mobile-device-detect';
export default {
  components: {
    LoadingSpinner,
    // InputWithMessage,
    ComboBoxWithMessage,
    ValidationSummery,
    // SearchableInput,
    DateTimePicker,
    TherapistProfile,
    TherapistPschologyOrganicationLink,
    CheckBoxWithMessage,
  },
  inject: ['WalletList', 'RefreshWalletList'],
  data() {
    return {
      isMobile: isMobile,
      hasMoreRecord: false,
      myTherapistList: [],
      newTherapistList: [],
      timePeriodList: [],
      scopeList: [],
      // topicList: [],
      clientID: 0,
      selectedID: 0,
      selectedSuggestedDate: null,
      selectedSuggestedFromTime: null,
      selectedSuggestedToTime: null,
      therapistFilterStatus: 'myTherapist',
      isLoadingNewTherapistList: false,
      myTherapistID: 0,
      newTherapistID: 0,
      showTherapistPrifile: true,
      showPsychologyOrganizationLink: true,
      emergencyRequestData: [],
      approveRequestID: 0,
      approveSessionID: 0,
      selectedTariffPriceDetailID: 0,
      minDate: null,
      maxDate: null,
      disableDates: null,
      searchData: {
        clientID: 0,
        recordCount: 9,
      },
      entity: {
        id: 0,
        clientID: 0,
        therapistID: null,
        sessionDate: null,
        sessionTimePeriod: 0,
        scopeID: null,
        // topicID: null,
        statusID: 1,
        description: null,
      },
      modalHasError: false,
      modalError: [],
      isInformationModalShown: false,
      // modalDeleteConfirmHasError: false,
      // deleteModalError: [],
      emergencySessionModal: new Object(),
      applyChangesConfirmModal: new Object(),
      approveSessionModal: new Object(),
      approveSessionConfirmModal: new Object(),
      informationModal: new Object(),
      modalApplyChangesHasError: false,
      applyChangesModalError: [],

      checkoutInvoiceHasError: false,
      checkoutInvoiceModalError: [],

      modalApproveSessionHasError: false,
      approveSessionModalError: [],
      approveModalMessage: '',

      emergencySessionEntity: {
        id: 0,
        sessionID: 0,
        clientID: 0,
        therapistID: 0,
        invoiceHeaderID: null,
        invoiceItemID: null,
        invoiceCode: null,
        sessionDate: null,
        fromTime: null,
        toTime: null,
        therapistName: '',
        sessionType: '',
        statusID: 0,
        sessionTypeID: 0,
        therapyTypeID: 0,
        clientCode: 0,
        isOverseas: false,
        sessionTariffList: [],
      },
      selectedWalletForInvoice: {
        balance: 0,
        currencyTypeID: 0,
        id: 0,
        title: '',
        wallet_CurrencyType: null,
      },
      usingWalletBalance: false,
      approveConfirmMode: '',
    };
  },
  methods: {
    cancelInformationModal() {
      this.informationModal.hide();
      this.isInformationModalShown = false;
    },
    openInformationModal() {
      this.isInformationModalShown = true;
      this.informationModal.show();
    },
    getPersianDateTime(date) {
      /* eslint-disable */
      return (
        new persianDate(new Date(date)).format('L') +
        ' ' +
        `${new persianDate(new Date(date)).format('LT')}`
      );
    },
    returnButtonClick() {
      this.$router.push({
        name: 'sessionsTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    getTime(time) {
      if (!time) {
        return '';
      }
      return time.toString().substr(0, 5);
    },
    getPersianDate(date, englishDigit) {
      if (!date) {
        return '';
      }
      /* eslint-disable */
      return new persianDate(new Date(date)).format('L', englishDigit);
    },
    getGregorianDate(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    getThousand(amount) {
      if (!amount) {
        return 0;
      }
      /* eslint-disable */
      return thousandSeprator(amount);
    },
    getWalletCurrencyTitle() {
      if (this.selectedWalletForInvoice && this.selectedWalletForInvoice.id) {
        return this.selectedWalletForInvoice?.wallet_CurrencyType?.title;
      }
      return '';
    },
    getGregorianDateTime(date) {
      // eslint-disable-next-line
      return getGregorianDateTime(date);
    },
    async moreEmergencyRequestClick() {
      this.searchData.recordCount += 9;
      await this.getEmergencyRequest();
    },
    async refreshButtonClick() {
      await this.getEmergencyRequest();
    },
    addButtonClick() {
      this.resetEntity();
      this.emergencySessionModal.show();
    },
    cancelModal() {
      this.resetEntity();
      this.emergencySessionModal?.hide();
      // this.emergencyRequestDeleteConfirmModal?.hide();
      this.applyChangesConfirmModal?.hide();
      this.approveSessionModal?.hide();
    },
    // deleteEmergencyRequest(id) {
    //   this.selectedID = id;
    //   this.emergencyRequestDeleteConfirmModal.show();
    // },
    applyChangesButtonClick(id, date, from, to) {
      this.selectedID = id;
      this.selectedSuggestedDate = date;
      this.selectedSuggestedFromTime = from;
      this.selectedSuggestedToTime = to;
      this.applyChangesConfirmModal.show();
    },
    async getEmergencySessionDetail() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get(
          `/ST/EmergencyRequest/GetEmergencySessionDetail?id=${that.approveRequestID}&&sessionID=${that.approveSessionID}`
        )
        .then((response) => {
          if (response.data?.success == false) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            return;
          }
          that.emergencySessionEntity = response.data;
          if (
            that.emergencySessionEntity.currencyTypeID &&
            that.emergencySessionEntity.currencyTypeID > 0
          ) {
            that.setInvoiceWallet(that.emergencySessionEntity.currencyTypeID);
          }
          that.approveSessionModal?.show();
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت داده های درخواست جلسه اورژانسی با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async approveSessionButtonClick(id, sessionID) {
      this.approveRequestID = id;
      this.approveSessionID = sessionID;
      await this.getEmergencySessionDetail();
    },

    getSelectedTariffPriceDetailCurrencyTitle() {
      let tariff = this.emergencySessionEntity.sessionTariffList.filter(
        (f) => f.tariffPriceDetailID == this.selectedTariffPriceDetailID
      );
      if (tariff && tariff.length > 0) {
        return tariff[0].currencyTypeTitle;
      }
      return '';
    },

    resetEntity() {
      this.entity = new Object({
        id: 0,
        clientID: 0,
        therapistID: null,
        sessionDate: null,
        sessionTimePeriod: 0,
        scopeID: null,
        // topicID: null,
        statusID: 1,
        description: null,
      });
      this.modalHasError = false;
      this.modalError = [];
      // this.modalDeleteConfirmHasError = false;
      // this.deleteModalError = [];
      this.selectedSuggestedDate = null;
      this.selectedSuggestedFromTime = null;
      this.selectedSuggestedToTime = null;
      this.modalApplyChangesHasError = false;
      (this.applyChangesModalError = []), (this.myTherapistID = 0);
      this.newTherapistID = 0;
      this.approveRequestID = 0;
      this.approveSessionID = 0;
      this.usingWalletBalance = false;

      this.selectedTariffPriceDetailID = 0;
      this.modalApproveSessionHasError = false;
      this.approveSessionModalError = [];
      this.approveModalMessage = '';
      this.checkoutInvoiceHasError = false;
      this.checkoutInvoiceModalError = [];
      this.$refs.myTherapistSelect?.hideErrorMessage();
      this.$refs.scopeSelect?.hideErrorMessage();
      // this.$refs.topicSelect?.hideErrorMessage();
      this.$refs.sessionDateInput?.hideErrorMessage();
      this.$refs.timePeriodSelect?.hideErrorMessage();
      // this.therapistFilterStatus = 'myTherapist';
      this.minDate = '';
      this.maxDate = '';
      this.resetTimePeriodList();
      this.disableDates = [];
    },
    myTherapistRadioClick() {
      this.therapistFilterStatus = 'myTherapist';
      this.resetEntity();
    },
    newTherapistRadioClick() {
      this.therapistFilterStatus = 'newTherapist';
      this.resetEntity();
    },
    dontcareTherapistRadioClick() {
      this.therapistFilterStatus = 'dontCareTherapist';
      this.resetEntity();

      let currentDate = new Date();

      this.minDate = this.getPersianDate(currentDate, true);
      this.maxDate = this.getPersianDate(
        currentDate.setDate(currentDate.getDate() + 30),
        true
      );
    },
    getTimeFromTimeSpan(time) {
      return (
        time.hours.toString().padStart(2, '0') +
        ':' +
        time.minutes.toString().padStart(2, '0') +
        ':' +
        time.seconds.toString().padStart(2, '0')
      );
    },
    async newTherapistSearchKeyPress(value) {
      if (value.length >= 3) {
        await this.getAllFilteredTherapistList(value);
      }
    },
    async getAllFilteredTherapistList(searchInput) {
      this.isLoadingNewTherapistList = true;
      let that = this;
      await axios
        .get(
          '/Basic/Therapist/GetTherapistListBySearch?therapistName=' +
            searchInput
        )
        .then((response) => {
          that.newTherapistList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات درمانگران با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          that.isLoadingNewTherapistList = false;
        });
    },
    async getMyTherapistList() {
      let that = this;
      await axios
        .get(
          '/Basic/Therapist/GetClientsTherapists?personID=' +
            this.$store.getters.userPersonID
        )
        .then((response) => {
          if (response.data.length == 0) {
            that.newTherapistRadioClick();
          } else that.myTherapistList = response.data;
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات درمانگران با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          that.isLoadingNewTherapistList = false;
        });
    },
    async scopeChanged(id) {
      let that = this;
      // get valid date from the server
      if (this.therapistFilterStatus == 'dontCareTherapist') {
        this.$refs.spinner.show();
        await axios
          .get(
            `/ST/EmergencyRequest/GetUnselectableDatesForEmergency?scopeID=${id}&&personID=${that.clientID}`
          )
          .then((response) => {
            that.disableDates = response.data;
            if (that.disableDates.length >= 30) {
              this.$refs.notification.show({
                type: 'error',
                title: `برای حوزه انتخاب شده تا 30 روز آینده هیچ جلسه اورژانسی جهت انتخاب وجود ندارد`,
              });
            }
          })
          .catch(() => {
            this.$refs.notification.show({
              type: 'error',
              title: `عملیات دریافت تاریخ های قابل انتخاب با خطا مواجه گردید.`,
            });
          })
          .finally(() => {
            this.$refs.spinner.hide();
          });
      }
    },
    async sessionDateChanged() {
      let that = this;
      if (this.therapistFilterStatus == 'dontCareTherapist') {
        if (!that.entity.scopeID || !that.entity.sessionDate) {
          return;
        }
        // get valid period from the server
        this.resetTimePeriodList();
        this.$refs.spinner.show();
        await axios
          .get(
            `/ST/EmergencyRequest/GetTimePeriodIDsForEmergency?scopeID=${that.entity.scopeID}&&personID=${that.clientID}&&sessionDate=${that.entity.sessionDate}`
          )
          .then((response) => {
            let ids = response.data;
            if (ids.length > 0) {
              that.timePeriodList = that.timePeriodList.filter((f) =>
                ids.includes(f.id)
              );
            }
          })
          .catch(() => {
            this.$refs.notification.show({
              type: 'error',
              title: `عملیات دریافت بازه زمانی قابل انتخاب با خطا مواجه گردید.`,
            });
          })
          .finally(() => {
            this.$refs.spinner.hide();
          });
      }
    },
    async getScopeList() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get('/Basic/Scope/GetPublic')
        .then((response) => {
          that.scopeList = response.data;
          //   .map((m) => {
          //     return { id: m.id, title: m.title };
          //   });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات حوزه‌ها با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    async getEmergencyRequest() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post(
          '/ST/EmergencyRequest/GetEmergencyRequestForSite/',
          that.searchData
        )
        .then((response) => {
          that.emergencyRequestData = response.data.emergencyRequestData;
          that.hasMoreRecord =
            response.data.allRecourdCount >
            response.data.emergencyRequestData.length;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت داده های درخواست جلسات اورژانسی با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    validate() {
      let valid = true;
      if (this.therapistFilterStatus == 'myTherapist' && !this.myTherapistID) {
        this.$refs.myTherapistSelect.showErrorMessage();
        valid = false;
      }

      if (
        this.therapistFilterStatus == 'newTherapist' &&
        !this.newTherapistID
      ) {
        this.$refs.myTherapistSelect.showErrorMessage();
        valid = false;
      }

      if (
        this.therapistFilterStatus == 'dontCareTherapist' &&
        !this.entity.scopeID
      ) {
        this.$refs.scopeSelect.showErrorMessage();
        valid = false;
      }

      // if (
      //   this.therapistFilterStatus == 'dontCareTherapist' &&
      //   !this.entity.tofpicID
      // ) {
      // this.$refs.topicSelect.showErrorMessage();
      //   valid = false;
      // }

      if (!this.entity.sessionDate) {
        this.$refs.sessionDateInput.showErrorMessage();
        valid = false;
      }

      if (!this.entity.sessionTimePeriod) {
        this.$refs.timePeriodSelect.showErrorMessage();
        valid = false;
      }

      return valid;
    },
    async confirmedModal() {
      if (!this.validate()) {
        return;
      }

      if (this.therapistFilterStatus == 'myTherapist') {
        this.entity.therapistID = this.myTherapistID;
      }
      if (this.therapistFilterStatus == 'newTherapist') {
        this.entity.therapistID = this.newTherapistID;
      }
      let that = this;
      that.entity.clientID = that.clientID;
      this.$refs.spinner.show();
      await axios
        .post('/ST/EmergencyRequest/CreateEmergencyRequest/', that.entity)
        .then(async (response) => {
          if (!response.data?.success) {
            that.modalHasError = true;
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            this.modalError = errorMessages;
            return;
          }

          this.cancelModal();
          that.$refs.notification.show({
            type: 'success',
            title: `درخواست جلسه اورژانسی با موفقیت ثبت شد`,
          });
          await this.getEmergencyRequest();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }

          this.$refs.notification.show({
            type: 'error',
            title: `ثبت درخواست جلسه اورژانسی با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    async confirmedApplyChangesModal() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post('/ST/EmergencyRequest/ApplyChangeEmergencyRequest', {
          id: that.selectedID,
          sessionDate: that.selectedSuggestedDate,
          fromTime: that.selectedSuggestedFromTime,
          toTime: that.selectedSuggestedToTime,
        })
        .then(async (response) => {
          if (!response.data?.success) {
            that.modalApplyChangesHasError = true;
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            this.applyChangesModalError = errorMessages;
            return;
          }

          this.cancelModal();
          that.$refs.notification.show({
            type: 'success',
            title: `درخواست جلسه اورژانسی با موفقیت تغییر یافت`,
          });
          await this.getEmergencyRequest();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `تغییر درخواست جلسه اورژانسی با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    getClientPhoneEmail() {
      return this.$store.getters.phone ?? this.$store.getters.email ?? '';
    },
    async checkoutInvoice() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post('/FN/InvoiceHeader/CheckoutInvoiceForSite', {
          invoiceHeaderID: that.emergencySessionEntity.invoiceHeaderID,
          clientName: that.$store?.getters?.userFullName,
          clientPhoneEmail: that.getClientPhoneEmail(),
          useWalletBalance: that.usingWalletBalance,
          description: '',
        })
        .then(async (response) => {
          if (!response.data?.success) {
            that.checkoutInvoiceHasError = true;
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            that.checkoutInvoiceModalError = errorMessages;
            that.cancelApproveConfirmModal();
            return;
          }

          if (response.data.success && response.data.returnValue) {
            // document.location = response.data.returnValue;
            window.location.href = response.data.returnValue;
            return;
          }

          this.cancelModal();
          that.$refs.notification.show({
            type: 'success',
            title: `جلسه اورژانسی با موفقیت تایید و نهایی شد`,
          });
          await this.getEmergencyRequest();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }

          this.$refs.notification.show({
            type: 'error',
            title: `تسویه صورت حساب جلسه اورژانسی با خطا مواجه شد`,
          });
          that.cancelApproveConfirmModal();
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async confirmedApproveSessionModal() {
      if (!this.emergencySessionEntity.hasInvoice) {
        if (
          this.emergencySessionEntity.sessionTariffList.length > 1 &&
          !this.selectedTariffPriceDetailID
        ) {
          this.$refs.sessionTariffPriceSelect.showErrorMessage();
          return;
        }

        if (
          this.emergencySessionEntity.sessionTariffList.length == 1 &&
          !this.selectedTariffPriceDetailID
        ) {
          this.selectedTariffPriceDetailID =
            this.emergencySessionEntity.sessionTariffList[0].tariffPriceDetailID;
        }
        this.approveModalMessage = `با تایید شما، برای این جلسه اورژانسی صورت حساب (با واحد پول: ${this.getSelectedTariffPriceDetailCurrencyTitle()}) صادر می شود. به منظور ثبت و نهایی کردن جلسه، شما می بایست صورت حساب را پس از صدور، هر چه سریعتر تسویه نمایید. از صدور صورت حساب اطمینان دارید؟`;

        this.approveConfirmMode = 'invoice';
        this.approveSessionConfirmModal.show();
      }

      if (this.emergencySessionEntity.hasInvoice) {
        // در صورتیکه غیر ریالی باشد
        if (this.emergencySessionEntity.currencyTypeID != 1) {
          if (
            this.selectedWalletForInvoice.balance <
            this.emergencySessionEntity.price
          ) {
            this.checkoutInvoiceHasError = true;
            this.checkoutInvoiceModalError = [];
            this.checkoutInvoiceModalError.push(
              `موجودی کیف پول، برای تسویه این صورت حساب کافی نمی باشد`
            );
            this.$refs.notification.show({
              type: 'error',
              title: `موجودی کیف پول، برای تسویه این صورت حساب کافی نمی باشد`,
            });
            return;
          }
          await this.checkoutInvoice();
        }
        //ریالی باشد
        if (this.emergencySessionEntity.currencyTypeID == 1) {
          if (
            (this.usingWalletBalance &&
              this.selectedWalletForInvoice.balance <
                this.emergencySessionEntity.price) ||
            !this.usingWalletBalance
          ) {
            this.approveModalMessage = `با توجه به انتخاب شما، مبلغ کل صورت حساب یا ما به تفاوت موجودی کیف پول و مبلغ کل صورت حساب را می بایست توسط درگاه پرداخت آنلاین پرداخت نمایید. آیا از انجام این عملیات اطمینان دارید؟`;

            this.approveConfirmMode = 'checkout';
            this.approveSessionConfirmModal.show();
          }

          if (
            this.usingWalletBalance &&
            this.selectedWalletForInvoice.balance >=
              this.emergencySessionEntity.price
          ) {
            await this.checkoutInvoice();
          }
        }
      }
    },
    setInvoiceWallet(currencyTypeID) {
      let wallet = this.WalletList().filter(
        (f) => f.currencyTypeID == currencyTypeID
      );
      if (wallet && wallet.length > 0) {
        this.selectedWalletForInvoice = wallet[0];
      }
    },
    cancelApproveConfirmModal() {
      this.approveSessionConfirmModal?.hide();
    },
    async confirmedApproveSessionDialog() {
      if (this.approveConfirmMode == 'invoice') {
        let that = this;
        this.$refs.spinner.show();
        await axios
          .post('/ST/EmergencyRequest/CreateInvoice', {
            id: that.approveRequestID,
            sessionID: that.approveSessionID,
            tariffPriceDetailID: that.selectedTariffPriceDetailID,
          })
          .then(async (response) => {
            if (!response.data?.success) {
              that.modalApproveSessionHasError = true;
              let errorMessages = response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                this.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              that.approveSessionModalError = errorMessages;
              return;
            }

            that.$refs.notification.show({
              type: 'success',
              title: `برای جلسه اورژانسی صورت حساب صادر شد. لطفا نسبت به تسویه آن اقدام نمایید`,
            });
            that.cancelApproveConfirmModal();
            await this.getEmergencySessionDetail();
          })
          .catch((error) => {
            if (!error.response.data.success) {
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              if (errorMessages && errorMessages.length > 0) return;
            }
            this.$refs.notification.show({
              type: 'error',
              title: `صدور صورت حساب برای درخواست جلسه اورژانسی با خطا مواجه شد`,
            });
          })
          .finally(() => {
            this.$refs.spinner.hide();
          });
      }

      if (this.approveConfirmMode == 'checkout') {
        await this.checkoutInvoice();
      }
    },
    resetTimePeriodList() {
      this.timePeriodList = [
        { id: 1, title: '7:00 - 12:00' },
        { id: 2, title: '12:00 - 17:00' },
        { id: 3, title: '17:00 - 23:00' },
      ];
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },
  },
  async mounted() {
    let that = this;
    const route = useRoute();
    that.clientID = route.params.id;
    that.searchData.clientID = route.params.id;
    await this.getMyTherapistList();
    await this.getScopeList();
    this.resetTimePeriodList();
    that.informationModal = new Modal(
      document.getElementById('informationModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    that.emergencySessionModal = new Modal(
      document.getElementById('emergencySessionModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );

    // that.emergencyRequestDeleteConfirmModal = new Modal(
    //   document.getElementById('emergencyRequestDeleteConfirmModal'),
    //   {
    //     keyboard: false,
    //     backdrop: 'static',
    //   }
    // );

    that.applyChangesConfirmModal = new Modal(
      document.getElementById('applyChangesConfirmModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    that.approveSessionModal = new Modal(
      document.getElementById('approveSessionModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    that.approveSessionConfirmModal = new Modal(
      document.getElementById('approveSessionConfirmModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );

    await that.getEmergencyRequest();
    that.$emergencyRequestHub.client.on(
      'ChangeEmergencyRequestStatusForSite',
      (model) => {
        if (model.clientID == that.clientID) {
          let foundedItems = that.emergencyRequestData.filter(
            (f) => f.id == model.id
          );
          if (foundedItems && foundedItems.length > 0) {
            foundedItems[0].statusID = model.statusID;
            foundedItems[0].suggestedSessionDate = model.suggestedSessionDate;
            if (model.suggestedFromTime?.ticks) {
              foundedItems[0].suggestedFromTime = that.getTimeFromTimeSpan(
                model.suggestedFromTime
              );
            }
            if (model.suggestedToTime?.ticks) {
              foundedItems[0].suggestedToTime = that.getTimeFromTimeSpan(
                model.suggestedToTime
              );
            }

            foundedItems[0].therapistDescription = model.therapistDescription;

            if (model.assignedFromTime?.ticks) {
              foundedItems[0].assignedFromTime = that.getTimeFromTimeSpan(
                model.assignedFromTime
              );
            }
            if (model.assignedToTime?.ticks) {
              foundedItems[0].assignedToTime = that.getTimeFromTimeSpan(
                model.assignedToTime
              );
            }

            foundedItems[0].assignedSessionDate = model.assignedSessionDate;
            foundedItems[0].emergencyRequestStatus =
              model.emergencyRequestStatus;
            foundedItems[0].therapistID = model.therapistID;
            foundedItems[0].therapistName = model.therapistName;
            foundedItems[0].sessionID = model.sessionID;
          }
        }
      }
    );

    that.showTherapistPrifile =
      that.$store.getters.showTherapistPicture == 'true' ? true : false;
    that.showPsychologyOrganizationLink =
      that.$store.getters.showTherapistPsychologyOrganizationLink == 'true'
        ? true
        : false;
    /* eslint-disable */
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  },
};
</script>
<style scoped>
.form-check-input[type='radio'] {
  float: right;
  margin-left: 5px;
  margin-right: 0;
}
.form-check-input:checked {
  background-color: #4c5e74 !important;
}
.hr-conclusion {
  background: -webkit-gradient(
    radial,
    50% 50%,
    0,
    50% 50%,
    150,
    from(#000),
    to(#fff)
  ) !important;
}
</style>
<style>
.tooltip {
  --bs-tooltip-bg: #fad776;
  --bs-tooltip-color: #303030;
  --bs-tooltip-font-size: 0.775rem;
  font-family: Vazir;
}
.hideModal {
  transition: opacity 0.5s;
  opacity: 0.1;
}
.showModal {
  opacity: 1;
}
</style>
